<template>
	<ul  class="list5"  >
		<el-skeleton :rows="5" :loading="loadingMask" animated>
			<li v-for="(item,index) in resultDataList">
				<L>
					<a @click="jumppush('/detail/'+item.id+'?col='+sourcecol)" v-html="item.articletype+item.title" ></a>
				</L>
				<R>
					{{item.publishtime.substring(0,10)}}
				</R>
			</li>
		</el-skeleton>
	</ul>
</template>

<script>
	export default {
		data() {
			return {
				loadingMask: false,
				pageNum: 1,
				pageSize: 5,
				resultTotalCount: 0,
				resultDataList:[]
			}
		},
		props:[
			'colid',
			'colname',
			'sourcecol',
		],
		watch: {
			
		},
		mounted: function() {
			this.getlistfnc();
		},
		methods: {
			jumppush:function(to){
				var a = document.createElement('a');
				a.setAttribute('href', to);
				a.setAttribute('style', 'display:none');  
				a.setAttribute('target', '_blank');  
				document.body.appendChild(a);
				a.click();
				a.parentNode.removeChild(a); 
			},
			getlistfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'subject/getHotSubjectArticles',
						responseType: 'json',
						params: {
							columnID: this.colid,
							iPage: this.pageNum,
							pageSize: this.pageSize,
						},
					})
					.then(function(response) {
						_this.resultDataList = response.data.data.data.data;
						_this.resultTotalCount=response.data.data.data.totalcount;
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
		}
	}
</script>

<style>
</style>